module.exports = __webpack_public_path__ + "img/4@3x.18d309f7.png";